var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{staticClass:"bb-checkbox",attrs:{"size":"lg","disabled":_vm.disabled},on:{"input":function($event){return _vm.onCheck($event)}},model:{value:(_vm.passedValue),callback:function ($$v) {_vm.passedValue=$$v},expression:"passedValue"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }